// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_mxe","cls2":"PaperAbstract-cls2_3tQ PaperAbstract-cls1_mxe","variant-dense":"PaperAbstract-variant-dense_HeM"};